import { render, staticRenderFns } from "./ShipBody.vue?vue&type=template&id=3c0f1d9a"
import script from "./ShipBody.vue?vue&type=script&lang=ts"
export * from "./ShipBody.vue?vue&type=script&lang=ts"
import style0 from "./ShipBody.vue?vue&type=style&index=0&id=3c0f1d9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports